export const DELIVERIES_RESET_STATE = 'DELIVERIES_RESET_STATE';
export const DELIVERIES_CURRENT_ITEM = 'DELIVERIES_CURRENT_ITEM';

export const DELIVERIES_REQUEST_LOADING = 'DELIVERIES_REQUEST_LOADING';
export const DELIVERIES_REQUEST_SUCCESS = 'DELIVERIES_REQUEST_SUCCESS';
export const DELIVERIES_REQUEST_FAILED = 'DELIVERIES_REQUEST_FAILED';

export const DELIVERIES_CURRENT_ACTION = 'DELIVERIES_CURRENT_ACTION';
export const DELIVERIES_RESET_ACTION = 'DELIVERIES_RESET_ACTION';